import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Idea() {
  return (
    <section className="nurs_idea p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center my-auto order-md-1 order-2"
          >
            <div className="solution_img">
              <StaticImage
                src="../../../images/case-studies/nurse-practition/tek_img_01.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={570}
                height={712}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={7}
            lg={7}
            xl={6}
            xxl={6}
            className="offset-xl-1 my-auto order-md-2 order-1"
          >
            <h2>
              The Idea That Led Us To Build
              <span style={{ color: "#6D4FC1" }}>
                 The Nurse Practitioners App
              </span>
            </h2>
            <p>
              The Nurse Practitioners application was built for a very specific
              reason – to revolutionize the healthcare system and convey the
              positive impact of technology to the end users. Most of us have
              faced difficulty regarding medical care, and going to a hospital
              is not always an option – this platform solves that problem but
              enables users to schedule visits or appointments for nursing staff
              and medics easily.
            </p>
            <p>
              From requesting a visit to having particular medical care
              requirements to needing virtual treatment from a nursing expert or
              consultant – everything can be managed through an application,
              including the scheduling, tracking, and payment processing.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Idea;
